import PropTypes from 'prop-types';
import {NavLink as ReactRouterLink} from 'react-router-dom';

const resolveClassName = className =>
    typeof className === 'function' ? className({isActive: false}) : className;

const isExternalLink = to => typeof to === 'string' && /^https?:\/\//i.test(to);

const Link = ({
    className,
    forceAnchor,
    to,
    children,
    onClick,
    activeClassName,
    ...props
}) => {
    if (forceAnchor || isExternalLink(to)) {
        return (
            <a
                className={resolveClassName(className)}
                href={to}
                onClick={onClick}
                {...props}
            >
                {children}
            </a>
        );
    }

    return (
        <ReactRouterLink
            className={className}
            to={to}
            onClick={onClick}
            activeClassName={activeClassName}
            {...props}
        >
            {children}
        </ReactRouterLink>
    );
};

Link.propTypes = {
    className: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    activeClassName: PropTypes.string,
    forceAnchor: PropTypes.bool,
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    children: PropTypes.node,
    onClick: PropTypes.func,
};

export default Link;
